import React, { ButtonHTMLAttributes, ElementType, ReactNode } from 'react';
import { Button as MuiButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface ButtonProps {
  children: string | ReactNode;
  component?: ElementType;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  busy?: boolean;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
  to?: string;
}

const Button = ({
  children,
  type,
  component = 'button',
  variant = 'contained',
  color,
  busy,
  disabled,
  startIcon,
  endIcon,
  onClick,
  size = 'medium',
  to,
}: ButtonProps) => {
  const classes = useStyles();

  return (
    <MuiButton
      component={component}
      to={to}
      variant={variant}
      color={color}
      type={type}
      disabled={busy || disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      size={size}
      className={classes.root}
    >
      {children}
    </MuiButton>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    whiteSpace: 'nowrap',
  },
}));

export default Button;
